var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M6.801 2.15c.44-.22.958-.22 1.398 0l4.161 2.081a.31.31 0 0 0 .28 0l3.224-1.612a1.563 1.563 0 0 1 2.261 1.398V14.42c0 .591-.334 1.133-.864 1.397L13.2 17.85c-.44.22-.958.22-1.398 0L7.64 15.77a.31.31 0 0 0-.28 0L4.136 17.38a1.562 1.562 0 0 1-2.261-1.398V5.58c0-.591.334-1.132.864-1.397zM7.5 5c.345 0 .625.28.625.625V12.5a.625.625 0 1 1-1.25 0V5.625c0-.345.28-.625.625-.625m5.625 2.5a.625.625 0 1 0-1.25 0v6.875a.625.625 0 1 0 1.25 0z",
    clipRule: "evenodd"
  })));
};
export default SvgMap;